import {
  get,
  flow,
  toLower,
  replace,
} from 'lodash/fp';
import {
  transformAttributeValue,
  getAttributeValue,
  getAttributeValueOr,
} from '../../helpers/getAttributeValue';

import PostMeasureOptionsCookie from '../../models/postMeasureOptionsCookie';
import getWindowCategoriesQueryString from '../../helpers/mandi/getWindowCategoriesQueryString';

const getMeasurementAttributeValue = transformAttributeValue(replace(/\.0$/, ''));

export default itemId => (dispatch, getState) => {
  const estimateBuilder = get('estimateBuilder', getState());

  const item = get(`entities.items.byId.${itemId}`)(estimateBuilder);
  const designId = get('designId')(item);
  const design = get(`entities.estimates.byId.${designId}`)(estimateBuilder);
  const containerId = get('containerId')(item);
  const container = get(`entities.containers.byId.${containerId}`)(estimateBuilder);

  const cookie = new PostMeasureOptionsCookie();

  const roomLabel = get('charLabel')(container);
  const roomName = get('name')(container);
  const windowLabel = get('charLabel')(item);
  const windowName = `${roomLabel}${windowLabel} ${roomName}`.substr(0, 10);

  cookie.jobUid = get('attributes.jobUid')(design);
  cookie.quoteUid = get('designId')(design);
  cookie.windowUid = get('itemId')(item);

  cookie.width = getMeasurementAttributeValue('width', item);
  cookie.height = getMeasurementAttributeValue('height', item);
  cookie.depth = getMeasurementAttributeValue('depth', item);
  cookie.windowName = windowName;
  cookie.roomName = roomName;
  cookie.roomLabel = roomLabel;
  cookie.windowDescription = `${roomLabel} Window ${windowLabel}`;
  cookie.tags = [(flow(
    getAttributeValueOr('inside', 'mountType'),
    toLower,
  ))(item)];
  cookie.isCutout = false;
  cookie.isPostMeasureMode = true;
  cookie.isSpecialtyShape = false;
  cookie.isRemake = false;
  // Need to save the filtersUrl to the cookie as well so that we can grab it
  // from PIP and PCP breadcrumbs
  cookie.destination = 'estimates';
  cookie.scrollOnReturn = true;

  const measurementCategory = getAttributeValue('category')(item);

  if (measurementCategory) {
    sessionStorage.setItem('shouldResetPlpFilters', 'true');

    const windowCategoryMappings = get('mandiAvailability.windowCategoryMappings', estimateBuilder);
    cookie.plpFilters = JSON.stringify(getWindowCategoriesQueryString(
      measurementCategory,
      windowCategoryMappings,
    ));
  }

  cookie.save();

  return cookie;
};
